package com.partejar.app.core.network

data class ApiConfig(
    val baseUrl: String
) {
    fun endpoint(path: String): String =
        "${baseUrl.trimEnd('/')}/${path.trimStart('/')}"
}
